import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FullScreenExitIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 16L8 16L8 19L10 19L10 14L5 14L5 16ZM8 8L5 8L5 10L10 10L10 5L8 5L8 8ZM14 19L16 19L16 16L19 16L19 14L14 14L14 19ZM16 8L16 5L14 5L14 10L19 10L19 8L16 8Z"
      fill="currentColor"
    />
  </svg>
);

FullScreenExitIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FullScreenExitIcon);
